<template>
	<div id="container" class="container bg minwidth">
		<myheader></myheader>
		<div class="detail-header minwidth">
			<div class="mx1360">
				<div class="search-box flex-r-c-c">
					<div class="sc-outer flex-r-c-c">
						<div class="input-box">
							<el-input placeholder="请输入18位证书编号，例如 CERT-2025001101-01" v-model.trim="keyword" clearable>
							</el-input>
						</div>
						<div class="sc-icon-outer flex-c-c-c">
							<div @click="searchDetail()" class="icon-box curadm">
								<img class="search-icon" src="../../static/zcsjk_search_icon2.png" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="mx1360 main-content">

				<div class="left-box">
					<div class="left-head">
						<ul class="bqlist">
							<li class="vcenter c1">已备案</li>
							<!-- <li v-show="baseInfo.level_text" class="vcenter c2">{{ baseInfo.level_text || "" }}</li> -->
						</ul>
						<div class="title-row">
							<div class="title">{{ baseInfo.goods_name || "-" }}</div>
							<div class="author">作者：<span class="at-name">{{ baseInfo.artist_name || baseInfo.artist_desc
								|| "-" }}</span></div>
						</div>
					</div>
					<div class="picbox">

						<ImageMagnifier :img-url="baseInfo.img" :container-width="'777px'" :max-height="'553px'"
							:scale="4" :mask-size="120" :preview-scale="4"></ImageMagnifier>
						<!-- <div class="bigpic">
						<img :src="baseInfo.img" class="p contain" />
						<el-image class="p" fit="contain" :src="baseInfo.img"
							:preview-src-list="[baseInfo.img]"></el-image>
					</div> -->
						<div class="smallpic ">
							<!-- <ImageSlider :images="markers" img-width="153px" img-height="103px" gap="12px" /> -->
							<ImageSlider v-if="markers.length > 0" :images="markers" img-width="241px"
								img-height="172px" gap="12px" @image-click="onImageClick" />
							<!-- 触发弹窗的按钮 -->
							<div v-if="markers.length == 0 && modelFile" class="sw-pr-box">
								<div class="sl-box cur">
									<div @click="openThree()" class="sl-img">
										<img class="sl-img-btn" :src="baseInfo.img" alt="">
									</div>
									<div class="sl-text">查看三维模型</div>
								</div>
								<!-- <div v-if="modelFile" title="查看三维模型" @click="openThree()" class="btn-outer curadm">
								<div class="btn-3d "></div>
							</div> -->
							</div>

						</div>
					</div>
				</div>

				<div class="rightbox">
					<div class="k">
						<div class="pd">
							<div class="tit">核心档案</div>
							<ul class="list">
								<li class="ut-li">
									<div class="t">备案编号</div>
									<div class="v">{{ baseInfo.goods_sn || "-" }}</div>
								</li>
								<li class="ut-li">
									<div class="t">资产类型</div>
									<div class="v">{{ baseInfo.type_name || "-" }}</div>
								</li>
								<li class="ut-li">
									<div class="t">当前持有人</div>
									<div class="v">{{ baseInfo.holder_name || "-" }}</div>
								</li>
								<li class="ut-li wb100">
									<div class="t">备案完成时间</div>
									<div class="v">{{ baseInfo.q_date || "-" }}</div>
								</li>
								<li class="attr-list wb100">
									<ul class="attr-ul">
										<li class="attr-li" :key="v.attr_id" v-for="v in attrShowList">
											<div class="t">{{ v.attr_name || '' }}</div>
											<div class="v">{{ v.attr_value || '' }}</div>
										</li>
									</ul>
								</li>

							</ul>
							<div @click="toggleDetail()" v-if="attrList.length > 4"
								:class="{ open: detailOpen == true }" class="more-btn">
								<div class="t1">{{ detailOpen == true ? "收起" : "展开" }}</div>
								<div class="icon-box">
									<i class="el-icon-arrow-down"></i>
								</div>
							</div>
							<!-- <div class="more-btn vcenter btn2">
								折叠
							</div> -->
							<div class="price-box">
								<div class="t">参考估值</div>
								<div class="v b">{{ baseInfo.market_price ? ('￥' +
									$util.formatNumber(baseInfo.market_price))
									: '未知' }}</div>
							</div>
						</div>
					</div>
					<div v-if="baseInfo.is_copyright == '2'" class="right-cert">
						<div class="cert-box">
							<div class="tit">权威增信与核验</div>
							<div class="ct-pr">
								<div class="pr-li li1 flex-r-b-c">
									<div class="left flex-r-s-c">
										<div class="icon-box flex-c-c-c">
											<img class="icon-img" src="../../static/qkl_icon1.png" alt="">

										</div>
										<div class="ct-title">
											<div class="t1">作品版权登记</div>
											<div class="t2 flex-r-s-c">
												<!-- <div class="circle"></div> -->
												<div>已登记</div>
											</div>
											<!-- <div class="t3 flex-r-s-c">
												<div>未登记</div>
											</div> -->
										</div>
									</div>
									<div class="right">
										<div @click="openCert()" class="cy-arrow c1 flex-c-c-c">
											查验
										</div>
									</div>
								</div>
								<div v-if="true" class="pr-li li2">
									<div class="main-ct flex-r-b-c">
										<div class="left flex-r-s-c">
											<div class="icon-box flex-c-c-c">
												<img class="icon-img" src="../../static/qkl_icon2.png" alt="">
											</div>
											<div class="ct-title">
												<div class="t1">国版链存证</div>
												<div class="t2 flex-r-s-c">
													<!-- <div class="circle"></div> -->
													<div>核验通过</div>
												</div>
											</div>
										</div>
										<!-- <div class="right">
											<div @click="goCheck('https://tpl.bjinternetcourt.gov.cn/index.html#/pcSearch')"
												class="cy-arrow c2 flex-c-c-c">
												查验
											</div>
										</div> -->
									</div>
									<div class="child-li flex-r-b-c">
										<div class="left flex-r-s-c">
											<div class="icon-box flex-c-c-c">
												<img class="icon-img" src="../../static/qkl_icon3.png" alt="">
											</div>
											<div class="child-title">
												<div class="t1">北京互联网法院(天平链)</div>
												<div v-if="baseInfo.evidence_num" class="ed-num">
													{{baseInfo.evidence_num|| '' }}</div>
											</div>
										</div>
										<div class="right">
											<div @click="goCheck('https://tpl.bjinternetcourt.gov.cn/index.html#/pcSearch')"
												class="btn-box2">
												核验<i class="el-icon-arrow-right"></i>
											</div>
										</div>
									</div>
									<div class="child-li flex-r-b-c">
										<div class="left flex-r-s-c">
											<div class="icon-box flex-c-c-c">
												<img class="icon-img" src="../../static/qkl_icon4.png" alt="">
											</div>
											<div class="child-title">
												<div class="t1">广州互联网法院(司法链)</div>
												<div v-if="baseInfo.evidence_num" class="ed-num">
													{{ baseInfo.evidence_num ? (baseInfo.evidence_num + ';xyl') : '' }}
												</div>
											</div>
										</div>
										<div class="right">
											<div @click="goCheck('https://bc.gzinternetcourt.gov.cn:9001/gzinternetcourt-evidence/index.html#/home')"
												class="btn-box2">
												核验<i class="el-icon-arrow-right"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <div v-if="baseInfo.product_id" class="ct-detail">
							<p class="nocert">未认证</p>
						</div> -->
						</div>
					</div>
					<div class="bottom-btn-box">
						<div class="bg-btn vcenter cur ">
							发起权属变更
						</div>
						<div v-if="baseInfo.certificate_img" @click="openFile(baseInfo.certificate_file)"
							class="dw-btn vcenter cur ">
							下载鉴定证书
						</div>
					</div>

				</div>
			</div>
		</div>


		<div class="detail-body minwidth">
			<div class="mx1360">
				<div class="tab">
					<ul>
						<li @click="tabValue = 1" :class="{ on: tabValue == 1 }" class="cur curadm ">区块链存证信息</li>
						<li @click="tabValue = 2" :class="{ on: tabValue == 2 }" class="cur curadm">权属流转历史</li>
						<!-- <li @click="tabValue = 3" :class="{ on: tabValue == 3 }" class="cur curadm">权威增信与核验</li> -->

					</ul>
				</div>
				<div class="info">
					<div v-show="tabValue == 1" class="chain-box">
						<div class="chain-list">
							<div class="chain-li">
								存证时间：{{ baseInfo.q_date || '-' }}
							</div>
							<div class="chain-li">
								文件哈希：{{ baseInfo.q_hash || '-' }}
							</div>
							<div class="chain-li">
								存证编号：{{ baseInfo.q_code || '-' }}
							</div>
						</div>
					</div>
					<div v-show="tabValue == 2" class="detail-lclist">
						<!-- <ul class="list">
							<li>
								<img src="@/static/z-icon-time2.png" class="icon" />
								<div class="t1">王**家 从 李**明处通过交易获得。 <span>2022年3月15日</span></div>
							</li>
							<li>
								<img src="@/static/z-icon-time2.png" class="icon" />
								<div class="t1">李**明完成首次备案。<span>2021年8月1日</span></div>
							</li>
						</ul> -->
					</div>
					<div v-show="tabValue == 3" class="cert-box">
						<div class="ct-pr">
							<div v-if="!baseInfo.product_id" class="pr-li li1 flex-r-b-c">
								<div class="left flex-r-s-c">
									<div class="icon-box flex-c-c-c">
										©
									</div>
									<div class="ct-title">
										<div class="t1">作品版权登记</div>
										<div v-if="baseInfo.product_id" class="t2 flex-r-s-c">
											<div class="circle"></div>
											<div>已登记</div>
										</div>
										<div v-else class="t3 flex-r-s-c">
											<div>未登记</div>
										</div>
									</div>
								</div>
								<div v-if="baseInfo.product_id" class="right">
									<div @click="openCert()" class="btn-box flex-c-c-c">
										查验>
									</div>
								</div>
							</div>
							<div v-if="false" class="pr-li li2">
								<div class="main-ct flex-r-b-c">
									<div class="sftb">司法同步</div>
									<div class="left flex-r-s-c">
										<div class="icon-box flex-c-c-c">
											国版
										</div>
										<div class="ct-title">
											<div class="t1">国版链存证</div>
											<div class="t2 flex-r-s-c">
												<div class="circle"></div>
												<div>核验通过</div>
											</div>
										</div>
									</div>
									<div class="right">
										<div class="btn-box flex-c-c-c">
											查验>
										</div>
									</div>
								</div>
								<div class="child-li flex-r-b-c">
									<div class="left flex-r-s-c">
										<div class="icon-box flex-c-c-c">
											法
										</div>
										<div class="child-title">
											<div class="t1">北京互联网法院 (天平链)</div>
										</div>
									</div>
									<div class="right">
										<div class="btn-box2 flex-c-c-c">
											核验>
										</div>
									</div>
								</div>
								<div class="child-li flex-r-b-c">
									<div class="left flex-r-s-c">
										<div class="icon-box flex-c-c-c">
											法
										</div>
										<div class="child-title">
											<div class="t1">广州互联网法院(司法链)</div>
										</div>
									</div>
									<div class="right">
										<div class="btn-box2 flex-c-c-c">
											核验>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- <div v-if="baseInfo.product_id" class="ct-detail">
							<p class="nocert">未认证</p>
						</div> -->
					</div>
				</div>
			</div>

		</div>


		<ZoomableImage :visible.sync="dialogVisible" :imageUrl="goods_img_original_url" :initialMarkers="initialMarkers"
			:focusMarker="focusedMarker" />
		<threeDialog ref="threeBox"></threeDialog>
		<myfooter></myfooter>
	</div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js";
import ZoomableImage from './components/ZoomableImage.vue'; // 
import ImageSlider from './components/ImageSlider.vue'; // 
import threeDialog from './components/threeDialog.vue'; // 
import ImageMagnifier from './components/goods-magnifier-zoom.vue';
export default {
	components: {
		ZoomableImage,
		ImageSlider,
		threeDialog,
		ImageMagnifier
	},
	data() {
		return {
			detailOpen: false,
			keyword: "",
			modelFile: "",
			goods_img_original_url: "",
			imgList: [],
			attrShowList: [],
			attrList: [],
			tabValue: 1,
			baseInfo: {
				id: "",
				cat_id: "",
				goods_sn: "",
				goods_name: "",
				market_price: "",
				qr_img: "",
				keywords: "",
				goods_desc: "",
				goods_img: "",
				goods_type: "",
				artist_id: "",
				artist_name: "",
				broker_id: "",
				holder_id: "",
				chip_no: "",
				chip_position: "",
				certificate_no: "",
				certificate_name: "",
				certificate_type: "",
				certificate_date: "",
				is_delete: "",
				is_pay: "",
				is_recommend: "",
				status: "",
				audit_remark: "",
				admin_id: "",
				admin_name: "",
				create_time: "",
				update_time: "",
				ip: "",
				ArtistPhoto: "",
				level: "",
				level_text: "",
				img: "",
				goods_img_original_url: "",
				certificate_img: "",
				product_id: "",
				verify_url_pc: "",
				evidence_num: '',
			},
			certificate_no: "",
			dialogVisible: false,
			focusedMarker: null,
			imgUrl: '', // 替换为你的图片
			markers: [
				// {
				// 	x: 600,
				// 	y: 400,
				// 	label: '中心',
				// 	info: '这是图片中心',
				// 	width: 50,
				// 	height: 50,
				// 	imgurl: "http://www.29029.com/photos/202208/1_20220803141510232.jpg"
				// },
			],
			initialMarkers: [],
		}
	},
	created() {
		that = this;
		this.certificate_no = util.getUrlParam("certificate_no");
	},
	mounted() {

		that.initData();
	},
	methods: {
		goCheck(url) {
			window.open(url)
		},
		openCert() {
			if (this.baseInfo.verify_url_pc) {
				window.open(this.baseInfo.verify_url_pc)

			} else {
				ty.alert("暂无作品版权登记信息")
			}
		},
		searchDetail() {
			ty.ajax('web/web/search', { certificate_no: this.keyword }).then((result) => {
				if (result.data.data) {
					this.certificate_no = this.keyword;
					// this.initData()
					util.tourl_blank("/assetdetail", { certificate_no: this.keyword })
				}
			});
		},
		openFile(url) {
			if (url) {
				window.open(url);
			}
		},
		downloadThis(url, index) {
			console.log(url);
			const link = document.createElement("a");
			fetch(url)
				.then((res) => res.blob())
				.then((blob) => {
					// 将链接地址字符内容转变成blob地址
					console.log(blob);
					link.href = URL.createObjectURL(blob);
					// console.log(link.href)
					link.download = this.baseInfo.goods_name;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
		},
		openThree() {
			this.$refs.threeBox.formShow(this.modelFile);
		},
		toggleDetail() {
			this.detailOpen = !this.detailOpen;
			if (this.detailOpen == true) {
				this.attrShowList = this.attrList;
			} else {
				this.attrShowList = this.attrList.slice(0, 4);

			}
		},
		initData() {
			if (this.certificate_no) {
				ty.ajax('web/web/search', {
					certificate_no: this.certificate_no
				}).then((result) => {
					that.baseInfo = result.data.data;
					if (!that.baseInfo.goods_img_original_url) {
						that.goods_img_original_url = that.baseInfo.img;
					} else {
						that.goods_img_original_url = that.baseInfo.goods_img_original_url;
					}
					that.modelFile = result.data.data.modelFile || ""
					that.imgList = result.data.data.imgList || [];
					// console.log(that.goods_img_original)
					if (that.imgList.length == 0) {
						that.imgList = [{ img_url: that.baseInfo.img }]
					}
					console.log("that.imgList", that.imgList)
					let list = result.data.data.collectList || [];
					if (result.data.data.attrList) {
						if (result.data.data.attrList.length > 0) {
							let attr = result.data.data.attrList;
							this.attrList = attr.filter((e, i, arr) => {
								return e.attr_index == '1'
							})
						}
						if (this.attrList.length > 4) {
							this.attrShowList = this.attrList.slice(0, 4)
						} else {
							this.attrShowList = this.attrList
						}

					}
					let cl = [];
					for (let e of list) {
						cl.push({
							x: e.point_x,
							y: e.point_y,
							label: e.place,
							info: '',
							width: 50,
							height: 50,
							imgurl: e.img_url
						})
					}
					that.markers = cl;
				});
			}

		},
		// focusOnMarker(label) {
		// 	this.focusedMarker = this.markers.find(m => m.label === label);
		// 	this.dialogVisible = true; // 如果对话框未打开，则打开
		// },
		onImageClick(e) {
			this.initialMarkers = []
			this.initialMarkers.push(e.item)
			this.focusedMarker = this.initialMarkers[0]
			this.dialogVisible = true; // 如果对话框未打开，则打开
		},
		openDetail() {
			this.initialMarkers = []
			this.initialMarkers.push(this.markers[0])
			this.focusedMarker = this.initialMarkers[0]
			this.dialogVisible = true; // 如果对话框未打开，则打开
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../style.scss'; //所有页面公用
@import '../style2.scss'; //所有页面公用
@import "./assetdetail.scss";
</style>